import type { AriaAttributes } from 'react';

/**
 * Whether a control should expose `aria-invalid="true"`: it has an `error`, or
 * the caller passed `aria-invalid` as `true` / `'true'`. One rule for every
 * form control, so the accepted values can't drift between them.
 */
export const isAriaInvalid = (
    error?: boolean,
    ariaInvalid?: AriaAttributes['aria-invalid']
): boolean => !!error || ariaInvalid === true || ariaInvalid === 'true';
